// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2RtDv","header":"Messages_header__1HIAe"};